export default __webpack_public_path__ + "static/media/logo.48e61a9d.png";